import { render, staticRenderFns } from "./InstallPage.vue?vue&type=template&id=a06e03d2"
import script from "./InstallPage.vue?vue&type=script&lang=js"
export * from "./InstallPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports